/**
 * Design-system units (1 unit = 0.25rem), so 330 caps the content at 1320px. Below that
 * width nothing changes — the cap only affects wide monitors, where the configurator
 * becomes hard to scan.
 */
export const NEW_VEHICLE_CONTENT_MAX_WIDTH = 330;
